import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
export function Button(props) {
    const { backgroundColor = {
        basic: 'hsl(21deg, 90%, 48%)',
        hover: 'hsl(21deg, 90%, 40%)',
    }, color = { basic: 'white', hover: 'white' }, style, onClick, children, disabled = false, } = props;
    return (_jsx("button", { style: style, onClick: onClick, css: css({
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 6,
            paddingBottom: 6,
            borderWidth: 1,
            borderColor: 'transparent',
            fontSize: '1.125em',
            borderRadius: 6,
            color: color.basic,
            minWidth: 30,
            justifyContent: 'center',
            backgroundColor: backgroundColor.basic,
            ':hover:enabled': {
                color: color.hover,
                backgroundColor: backgroundColor.hover,
            },
            ':disabled': {
                opacity: 0.5,
                cursor: 'not-allowed',
            },
        }), type: "button", disabled: disabled, children: children }));
}
//# sourceMappingURL=Button.js.map